import NewSubscription from "../../components/subscription/NewSubscription.tsx";
import { useParams, useSearchParams } from "react-router";

function NewSubscriptionPage() {
  const { teacherId } = useParams();
  const [searchParams] = useSearchParams();
  const locationId = searchParams.get("locationId");
  const instrument = searchParams.get("instrument");
  const locationType = searchParams.get("locationType");
  return (
    <div>
      <NewSubscription
        teacherId={teacherId || ""}
        locationIdQuery={locationId}
        instrumentQuery={instrument}
        lessonTypeQuery={locationType}
      />
    </div>
  );
}

export default NewSubscriptionPage;
